
import ArrowDownward from '@mui/icons-material/ArrowDownward';
import ArrowUpward from '@mui/icons-material/ArrowUpward';
import { IGetWalletTransactionsResponse } from '../../../models/wallet.model';
import ShoppingBasketOutlinedIcon from '@mui/icons-material/ShoppingBasketOutlined';

interface IWalletCard extends IGetWalletTransactionsResponse {
    purchaseDetail: Function

}

export default function WalletCard({ amount, description, transactionDatePersian, purchaseDetail, saleId }: IWalletCard) {

    return (
        <>
            <div style={{
                display: "grid",
                border: '1px solid var(--border-color)',
                margin: 'auto',
                borderRadius: '5px',
                background: 'var(--input-bg-color)',
                alignContent: 'center',
                marginTop: '10px',
                padding: "20px"
            }}>
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                    <div style={{ alignContent: "flex-start", color: "var(--primary-text-color)" }}>
                        {amount > 0 ? <ArrowDownward style={{ color: "#0AB494", width: "20px", height: "20px" }}></ArrowDownward> : <ArrowUpward style={{ color: "#FF617C", width: "20px", height: "20px" }}></ArrowUpward>}
                        <span style={{ fontSize: "1rem", fontWeight: "bold", paddingRight: "5px" }}>{Math.abs(amount).toLocaleString('fa')}</span>
                        <span style={{ fontSize: "0.8rem", marginRight: "5px" }}>ریال</span>
                    </div>
                    <div className='text-[var(--primary-text-color)]' style={{ alignContent: "flex-end" }}>
                        <span style={{ fontSize: "0.7rem" }}>{transactionDatePersian}</span>
                    </div>
                </div>
                <hr style={{ color: 'var(--hr-color)', borderTop: "1px solid", }} className='py-2 mt-2' />
                <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>

                    <div style={{ display: "flex" }}>
                        <span style={{ fontSize: "0.7rem", color: "var(--tirnary-text-color)" }}>{description}</span>
                    </div>
                    {saleId && <div className='flex items-center justify-center text-[var(--primary-text-color)]' onClick={() => purchaseDetail()}>
                        <ShoppingBasketOutlinedIcon sx={{ marginLeft: "5px", fontSize: "13px" }} />
                        <span style={{ fontSize: "0.7rem", fontWeight: "bold" }}>جزییات خرید</span>
                    </div>}
                </div>
            </div>
        </>
    );
}
